export default __webpack_public_path__ + "static/contracting-awards-27dfcb9b2738767c20696b48accfdd2c.jpg";